<template>
  <div class="calendar-container mb-5" v-if="contentDataLoaded" v-show="childDataLoaded">
    <router-view name="dayNavigation"></router-view>
    <div class="hidden-calendar-daily" v-html="monthlyLeadIn"></div>

    <div class="hidden-calendar-monthly" v-html="dailyLeadIn"></div>
    <router-view @dataLoaded="onChildDataLoaded"></router-view>
  </div>
  <div class="progress" v-if="!(contentDataLoaded && childDataLoaded)">
    <div
      class="progress-bar progress-bar-striped progress-bar-animated"
      role="progressbar"
      aria-valuenow="100"
      aria-valuemin="0"
      aria-valuemax="100"
      style="width: 100%"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, provide, onMounted, ref } from 'vue';
import CalendarAppParam from "./composables/application-parameter";
import * as CalendarClient from "./composables/calendar-client";
import * as ContentModel from "./composables/calendar-content-model";
import * as CalendarModel from "./composables/calendar-model";

export default defineComponent({
  setup() {
    // Static Properties
    const appParam = inject(CalendarAppParam)!;

    // Reactive Properties
    const contentDataLoaded = ref(false);
    const childDataLoaded = ref(false);
    const contentLookup = ref(new ContentModel.ContentLookupClass());
    const filteredExtCalendarId = ref(null as string | null);
    provide(ContentModel.ContentLookup, contentLookup);
    provide(CalendarModel.FilteredExtCalendarId, filteredExtCalendarId);

    const onChildDataLoaded = (isDailyView: boolean) => {
      childDataLoaded.value = true;
      if(isDailyView) {
        document.body.classList.add("calendar-daily");
        document.body.classList.remove("calendar-monthly");
      } else {
        document.body.classList.add("calendar-monthly");
        document.body.classList.remove("calendar-daily");
      }
    };

    // Queries
    const provideActivitiesByPark = async () => {
      const contentMapping = [] as ContentModel.CalendarActivityContentResponseDto[];

      for (const parkCmsKey of appParam.parkCmsKeys) {
        const activityContent = await CalendarClient.getActivityContent(parkCmsKey);
        contentMapping.push(activityContent!);
      }

      contentLookup.value = new ContentModel.ContentLookupClass(contentMapping);
      contentDataLoaded.value = true;
    };

    // Reactions
    onMounted(provideActivitiesByPark);

    // return Model
    return {
      contentDataLoaded,
      childDataLoaded,
      onChildDataLoaded,
      monthlyLeadIn: appParam?.monthlyLeadIn,
      dailyLeadIn: appParam?.dailyLeadIn
    }
  }
});
</script>
